import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getMeetingList = (meetingPayload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_MEETING_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(`${BASE_URL}/meeting/list`, meetingPayload, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_MEETING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_MEETING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_MEETING_LIST_FAILED", payload: error?.response?.data?.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewMeeting = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_MEETING_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(`${BASE_URL}/meeting/view-meeting/${id}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_MEETING_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_MEETING_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_MEETING_FAIL", payload: error.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
